export const downloadBlob = (blob: Blob, name: string) => {
  const node = document.createElement('a')
  node.download = name
  const link = URL.createObjectURL(blob)
  node.setAttribute('href', link)
  document.body.appendChild(node)
  node.click()
  document.body.removeChild(node)
}
